module.exports = __webpack_public_path__ + "static/img/pic_daoshi_zm@2x.6e0dd724.png";